/// <reference path="../../TypeLite.Net4.d.ts" />
import * as React from 'react';
import { ResourceProvider } from '../../resourceProvider';
import { showFilterMobilePage } from '../../store/filterMobilePage/actions';
import { connect } from 'react-redux';
import { Dispatch } from 'redux';
import { getContentPath } from './../../utils/api';

const arrowDownIcon = getContentPath() + 'img/arrow-down.svg'

export enum FilterType {
	NoCar,
	Partial,
	Full
}

export interface IFilterMobileProps {
	selectedCountryValue: string;
	onShowCountriesPage: () => void;
	onShowWizardPage: () => void;
	filterType: FilterType;
	isCountrySelected: boolean;
}

interface IPropsFromDispatch {
	readonly showFilterMobilePage: typeof showFilterMobilePage
}

type FilterMobileProps = IFilterMobileProps & IPropsFromDispatch

class FilterMobileMenu extends React.Component<FilterMobileProps, {}>
{
	constructor(props: FilterMobileProps) {
		super(props);
		this.showWizardOrFilterPage = this.showWizardOrFilterPage.bind(this);
	}

	public componentDidMount() {
		let filter = document.getElementById("filter-mobile");
		let header = document.getElementsByClassName("k2ng-zone-name-Header");
		let page = document.getElementsByClassName('page');

		//FIXED POSITION MOBILE FILTER BUT NOT FIXED CHROMELAYOT HEADER

		document.body.addEventListener('scroll', () => {
			if (header.length > 0 && filter && filter.offsetWidth > 0 && filter.offsetHeight > 0) {
				let windowOffset = document.getElementsByTagName('body')[0].scrollTop;

				if (windowOffset > header[0].clientHeight) {
					filter.classList.add("fix-filter");
					if (page.length > 0) {
						(page[0] as HTMLElement).style.paddingTop = filter.clientHeight +'px';
					}
				} else if (windowOffset <= header[0].clientHeight) {
					filter.classList.remove("fix-filter");
					if (page.length > 0) {
						(page[0] as HTMLElement).style.paddingTop = '0px';
					}
				}
			} else if (!filter || !(filter.offsetWidth > 0 && filter.offsetHeight > 0)) {
				if (page.length > 0) {
					(page[0] as HTMLElement).style.paddingTop = '0px';
				}
			}
		});
	}

	public render() {
		const { isCountrySelected, filterType, selectedCountryValue, onShowCountriesPage, onShowWizardPage } = this.props;

		let filterMobileClassName = "filter-mobile-model";
		if (!isCountrySelected)
			filterMobileClassName += " disabled";

		return (
			<div className="filter-mobile-wrapper">
				{this.renderSvgImageTablet()}
				{this.renderSvgImageMobile()}
				<div className="filter-mobile-content row">
					<div>
						<div className="filter-mobile-country">
							{this.renderSelectedCountry(selectedCountryValue, isCountrySelected, onShowCountriesPage)}
							<img src={arrowDownIcon} onClick={() => onShowCountriesPage()} className="icon-arrow"/>
						</div>
					</div>
					<div>
						<div className={filterMobileClassName} onClick={() => this.showWizardOrFilterPage()}>
							<div className="filter-car-image"/>
							<div className={this.getFilterWizardIcon(filterType)}/>
						</div>
					</div>
				</div>
			</div>
		);
	}

	private showWizardOrFilterPage(): void {
		if (this.props.filterType === FilterType.NoCar) {
			this.props.onShowWizardPage();
		} else {
			this.props.showFilterMobilePage();
		}
	}

	private getFilterWizardIcon(filterType: FilterType): string {
		if (filterType === FilterType.Full) {
			return 'filter-icon-wizard-full';
		} else if (filterType === FilterType.Partial) {
			return 'filter-icon-wizard-partial';
		}
		return 'filter-icon-wizard-no-car';
	}

	private renderSelectedCountry(value: string, isSelected: boolean, onclickFunction: () => void): JSX.Element {
		if (isSelected) {
			return (
				<div className="filter-selected-item" onClick={() => onclickFunction()}>{value}</div>
			);
		} else {
			return (
				<div className="filter-unselected-item" onClick={() => onclickFunction()}>{ResourceProvider.getText('Filter.Item.UnselectedCountry')}</div>
			);
		}
	}

	private renderSvgImageTablet(): JSX.Element {
		return (
			<div className="d-sm-hidden filter-tablet-container">
				<svg id="svg-tablet" viewBox="0 0, 768 104" className="filter-mobile-svg">
					<rect className='svg-background-tablet' width="768" height="104" />
					<path className="svg-path" d="M646.2,0.0L646.2,104.0" id="svg_2" />
				</svg>
			</div>
		);
	}

	private renderSvgImageMobile(): JSX.Element {
		return (
			<div className="d-md-hidden filter-mobile-container">
				<svg id="svg-mobile" viewBox="0 0, 320 70" className="filter-mobile-svg">
					<rect className='svg-background-mobile' width="320" height="70" />
					<path className="svg-path" d="M252.2,0.0L252.2,70.0" id="svg_2" />
				</svg>
			</div>
		);
	}
}

const mapDispatchToProps = (dispatch: Dispatch) => ({
	showFilterMobilePage: () => dispatch(showFilterMobilePage())
})

export default connect(
	null,
	mapDispatchToProps
)(FilterMobileMenu)
